import baseUrl from "../utils/baseUrl";
import axios from "./api";

const getMechanicPointsConfig = async (mechanicId) =>
    await axios
        .get(baseUrl + `/mechanic-points-config/mechanic/${mechanicId}`)
        .then((response) => response.data);

const saveMechanicPointsConfig = async (mechanicId, request) =>
    await axios
        .put(baseUrl + `/mechanic-points-config/mechanic/${mechanicId}`, request)
        .then((response) => response.data);

export { getMechanicPointsConfig, saveMechanicPointsConfig };
